export const CLIENT_STORAGE_QUERY_KEYS = {
  all: ['clientStorage'] as const,
  item: (key: string) => ['clientStorage', key] as const,
  list: ['clientStorage', 'list'] as const,
  deleteItem: ['clientStorage', 'deleteItem'] as const,
  setItem: ['clientStorage', 'setItem'] as const,
} as const;
